import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import ServicesPage from './pages/ServicesPage';
import HiringPage from './pages/HiringPage';
import ContactPage from './pages/ContactPage';

const AppWrapper = () => {
  const clickSoundRef = useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    // Play click sound on route change
    if (clickSoundRef.current) {
      clickSoundRef.current.currentTime = 0;
      clickSoundRef.current.play().catch(() => {}); // Avoid promise errors
    }
  }, [location]);

  return (
    <>
      {/* Global Click Sound */}
      <audio
        ref={clickSoundRef}
        src="/mixkit-modern-technology-select-3124.wav"
        preload="auto"
      />

      <Header />
      <main style={{ minHeight: 'calc(100vh - 160px)' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/hiring" element={<HiringPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
};

export default App;